module.exports = __webpack_public_path__ + "static/media/no-revisions-uH1EgiuWtY8-unsplash.7df70751.jpg";